import { JsonProperty } from "../../../models/utilities/json-property";

export class AgingReportInvoice {
    
    public invoiceNumber : string = ''
    
    @JsonProperty({ toType: 'date' })
    public invoiceDate : Date | undefined = undefined
    
    @JsonProperty({ toType: 'date' })
    public dueDate : Date | undefined = undefined
    
    public amount : number = 0;
    
    public daysOverdue : number = 0;

}


export class AgingReport {

    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date | undefined = undefined;
    
    public currencyType : string = '';
    
    public dealerName : string = '';
    
    public currentBalance : number = 0.0;
    
    public balance1To30Days : number = 0.0;
    
    public balance31To60Days : number = 0.0;
    
    public balance61To90Days : number = 0.0;
    
    public balance91To120Days : number = 0.0;
    
    public balanceOver120Days : number = 0.0;

    public total : number = 0.0;
    
    public creditLimit : number = 0.0;

    public regionId : number|undefined = undefined;

    public rsmName : string = '';
    
    public availableCredit : number = 0.0;

    @JsonProperty({ toClass: AgingReportInvoice, designType: 'array' })
    public invoices : AgingReportInvoice[] = [];
    
    //
    // Helper Methods
    public getCurrent() {
        return this.reduceOrders(0, 0);
    }

    public getOneThirty() {
        return this.reduceOrders(1, 30);
    }

    public getThirtySixty() {
        return this.reduceOrders(31, 60);
    }

    public getSixtyNinety(){
        return this.reduceOrders(61, 90);
    }

    public getNinetyOneTwenty(){
        return this.reduceOrders(91,120);
    }

    public getOneTwentyPlus(){
        return this.reduceOrders(121,100000000);
    }

    private reduceOrders(start:number, end: number) {
        return this.invoices
        .filter((itm:AgingReportInvoice) => {
            if(start === 0 && end === 0 && itm.daysOverdue <= 0) {
                return true;
            }
            else {
                return itm.daysOverdue >= start && itm.daysOverdue <= end
            }
        })
        .reduce((sum : { amount: number, count: number, percentage: number }, curr : AgingReportInvoice) => { 

            sum.amount += curr.amount;
            sum.count += 1;
            sum.percentage = (sum.count / this.invoices.length) * 100;

            return sum;
        }, { amount: 0, count: 0, percentage: 0 });
    }
}